
// sections: minicart / main-cart
class CartTimer extends HTMLElement {
  constructor(){
    super();

    var self = this;
    let time = parseInt(this.dataset.time);

    let now, finalDate, timerInterval = false;

    if(localStorage.getItem('cartTimerEnd')) {
      now = localStorage.getItem('cartTimerActual');
      finalDate = localStorage.getItem('cartTimerEnd');
    } else {
      now = new Date().getTime();
      finalDate = new Date(now + time * 6e4).getTime();
      localStorage.setItem('cartTimerActual', now);
      localStorage.setItem('cartTimerEnd', finalDate);
    }

    const timer = () => {
      now = new Date().getTime();
      localStorage.setItem('cartTimerActual', now);
      let diff = finalDate - now;

      if(diff < 0) {
        self.innerHTML = '<span>'+ Shopify.translation.timer_ended +'</span>';
        if(diff < -86400000) localStorage.removeItem('cartTimerInitial'), localStorage.removeItem('cartTimerEnd')
        if(timerInterval) clearInterval(x);
      } else {
        let minutes = Math.floor(diff % (1e3*60*60)/ (1e3*60));
        let seconds = Math.floor(diff % (1e3*60) / 1e3);

        minutes <= 9 ? minutes = `0${minutes}` : minutes;
        seconds <= 9 ? seconds = `0${seconds}` : seconds;

        if(minutes > 0) var text = Shopify.translation.date.m
        else var text = Shopify.translation.date.minute

        self.querySelector('.dynamic').textContent = minutes + ':' + seconds + ' ' + text;
      }
    };

    timer();
    timerInterval = true;
    const x = setInterval(timer, 1000);
  }
}
customElements.define('cart-timer', CartTimer);

theme.Cart = (function(){
  function Cart(container){
    this.container = container;
    var self = this;

    this.cartFooter = this.container.querySelector('[data-sticky-mobile]');

    if(this.container.classList.contains('cart') && this.cartFooter && this.cartFooter.getAttribute('data-sticky-mobile') == "true"){
      if(document.documentElement.clientWidth < 779){
        self.setPosition();
      } else {
        self.unsetPosition();
      }

      window.on('resize', theme.utils.debounce(300, function() {
        if(document.documentElement.clientWidth < 779){
          self.setPosition();
        } else {
          self.unsetPosition();
        }
      }));
    } else {
      self.unsetPosition();
    }
  
    if(this.container.getAttribute('data-keep-on-page') == "true") this.keepOnPage();
    if(this.container.querySelector('shipping-calculator')) this.shippingCalculator();

    this.initListeners();

    document.addEventListener('updateCart', function(e){
      self.getCart();
    });
  }

  Cart.prototype = Object.assign({}, Cart.prototype, {
    initListeners(){
      var self = this;
      window.AddCount = 0;

      this.container.querySelectorAll('.quantity__button').forEach((button) => {
        button.addEventListener('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          self.updateItem(this.href);
        });
      });

      this.container.querySelectorAll('input.quantity__input').forEach((input) => {
        input.addEventListener('change', function(e){
          e.preventDefault();
          e.stopPropagation();
          self.updateInputItem(this);
        });
      });

      this.container.querySelectorAll('select.cart__selector-variant').forEach((select) => {
        select.addEventListener('change', function(e){
          e.preventDefault();
          self.updateVariant(this.value, this.dataset.actual, this.dataset.quantity);
        });
      });
    },

    removeListeners(){
      document.removeEventListener('updateCart', function(){
        self.getCart();
      });

      this.container.querySelectorAll('.quantity__button').forEach((button) => {
        button.removeEventListener('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          self.updateItem(this.href);
        });
      });

      this.container.querySelectorAll('input.quantity__input').forEach((input) => {
        input.removeEventListener('change', function(e){
          e.preventDefault();
          e.stopPropagation();
          self.updateInputItem(this);
        });
      });

      this.container.querySelectorAll('select.cart__selector-variant').forEach((select) => {
        select.removeEventListener('change', function(e){
          e.preventDefault();
          self.updateVariant(this.value, this.dataset.actual, this.dataset.quantity);
        });
      });
    },

    updateItem(url){
      this.container.innerHTML += Shopify.theme_settings.loader;
      this.container.classList.add('loading');

      window.ajaxURL(url).then(function () {
        document.dispatchEvent(new CustomEvent('updateCart'));
      });
    },

    updateInputItem(input) {
      var self = this;

      this.container.innerHTML += Shopify.theme_settings.loader;
      this.container.classList.add('loading');

      if(document.querySelectorAll('.cart-bubble')){
        document.querySelectorAll('.cart-bubble').forEach((bubble) => {
          bubble.innerHTML = Shopify.theme_settings.loader
        });
      }

      window.ajaxURL(theme.routes.cart_change_url + '?quantity=' + input.value + '&id=' + input.dataset.lineId).then(function () {
        document.dispatchEvent(new CustomEvent('updateCart'));
      });
    },

    updateVariant(variantId, actual, quantity){
      var self = this;

      this.container.innerHTML += Shopify.theme_settings.loader;
      this.container.classList.add('loading');

      if(document.querySelectorAll('.cart-bubble')){
        document.querySelectorAll('.cart-bubble').forEach((bubble) => {
          bubble.innerHTML = Shopify.theme_settings.loader
        });
      }

      window.ajaxURL(theme.routes.cart_change_url + '?quantity=' + quantity + '&id=' + actual)
      .then(function () {
        window.ajaxURL(theme.routes.cart_add_url + '?quantity=1&id=' + variantId)
        .then(function(){
          document.dispatchEvent(new CustomEvent('updateCart'));
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    },

    getCart(){
      var self = this;

      window.ajaxURL('/cart').then(function(data){
        self.renderCart(data);
      });
    },

    renderCart(data){
      var self = this;
      let response = new DOMParser().parseFromString(data, 'text/html'),
          container,
          miniCart,
          ContentSource,
          Content;

      if(self.container.classList.contains('minicart-container') && !self.container.closest('.cart-section')) {
        container = '.minicart-container',
        miniCart = true
      } else {
        container = '.cart-section',
        miniCart = false
      }

      if(document.querySelectorAll('.cart-bubble')){
        document.querySelectorAll('.cart-bubble').forEach((bubble) => {
          if(response.querySelector('.cart-bubble').innerHTML > 0){
            bubble.classList.remove('hide'),
            bubble.innerHTML = response.querySelector('.cart-bubble').innerHTML;
          } else {
            bubble.classList.add('hide')
          }
        });
      }

      if(response.querySelector(container + ' .cart__empty') && !self.container.querySelector('.cart__empty')){
        self.container.querySelectorAll(':not(.cart__heading):not(.cart__cross-sell):not(.cart__content)[id^="block').forEach((block) => {
          block.classList.add('hide');
        });

        if(localStorage.getItem('cartTimerInitial')) {
          localStorage.removeItem('cartTimerInitial'),
          localStorage.removeItem('cartTimerEnd')
        }

        if(miniCart) {
          self.container.querySelector(container + ' .cart').innerHTML = response.querySelector(container + ' .cart').innerHTML
        }

      } else {
        if(miniCart){
          if(self.container.querySelector('.cart__empty')) {
            self.container.querySelector(container + ' .minicart-blocks').innerHTML = response.querySelector(container + ' .minicart-blocks').innerHTML
          } else {
            self.container.querySelector(container + ' .cart__content').innerHTML = response.querySelector(container + ' .cart__content').innerHTML
          }

          self.container.querySelector(container + ' .minicart-footer').innerHTML = response.querySelector(container + ' .minicart-footer').innerHTML
        } else {
          if(self.container.querySelector('.cart__empty')) {
            self.container.querySelector(container + ' .cart__wrapper').innerHTML = response.querySelector(container + ' .cart__wrapper').innerHTML
          } else {
            self.container.querySelector(container + ' .cart__content').innerHTML = response.querySelector(container + ' .cart__content').innerHTML
            self.container.querySelector(container + ' .cart__footer:not(.added)').innerHTML = response.querySelector(container + ' .cart__footer:not(.added)').innerHTML
          }
        }

        self.container.querySelectorAll(':not(.cart__heading):not(.cart__cross-sell):not(.cart__content)[id^="block').forEach((block) => {
          block.classList.remove('hide');
        });
      }

      if(miniCart){
        if(this.container.closest('mini-cart')){
          this.container.closest('mini-cart').bindEvents();

          // Render miniCart
          if(document.querySelectorAll('mini-cart').length > 0 && (Shopify.theme_settings.atc_action == "once" || Shopify.theme_settings.atc_action == "always") && window.location.href.indexOf("cart") == -1){
            var miniCartContainer = document.querySelector('.menu-icons mini-cart');
            document.body.classList.remove('scroll_up');
            document.body.classList.remove('scroll_down');
            miniCartContainer.open();
          }
        }
      } else {
        if(self.container.querySelector('product-form')) {
          self.container.querySelectorAll('product-form').forEach((product) => {
            const form = product.querySelector('form');

            if(form){
              form.addEventListener('submit', product.onSubmitHandler.bind(product));
            }
          })
        }
      }

      self.initListeners();

      self.container.querySelectorAll('.loader').forEach(loader => loader.remove());
      self.container.classList.remove('loading');

      if(self.container.querySelector('shipping-calculator')) {
        let width = parseFloat(response.querySelector(".cart__shipping-progress-bar").dataset.width),
            left = parseFloat(response.querySelector(".cart__shipping-progress-bar").dataset.left);

        setTimeout(function(){
          self.shippingCalculator(width, left)
        }, 500);
      }
    },

    setPosition(){
      if(this.cartFooter){
        var content = this.cartFooter.cloneNode(true);
        this.cartFooter.classList.add('hide');
        content.classList.add('added'); 
        document.querySelector('.page-element').appendChild(content);
        document.querySelector('footer').style.marginBottom = content.offsetHeight + 'px';
      }
    },

    unsetPosition() {
      document.querySelector('footer').style.marginBottom = '';
      if(this.cartFooter) this.cartFooter.classList.remove('hide');
      if(document.querySelector('.page-element').querySelector('.added[data-sticky-mobile]')) {
        document.querySelector('.page-element').querySelector('.added[data-sticky-mobile]').remove();
      }
    },

    checkStatusProductForm(productForm, reached, has_changed) {
      const form = productForm.querySelector('form'),
            quantity = productForm.querySelector('[name="quantity"]');

      if(productForm.dataset.added == "true" && !reached){
        quantity.value = 0
        form.setAttribute("action", form.getAttribute("action").replace('add', 'change'))
        productForm.querySelector('button[type="submit"]').click()
        productForm.dataset.added = "false"
        quantity.value = 1
        form.setAttribute("action", form.getAttribute("action").replace('change', 'add'))
      }

      if(has_changed) {
        if(reached) {
          if(productForm.dataset.added == "false"){
            productForm.querySelector('button[type="submit"]').click()
            productForm.dataset.added = "true"
          }

          form.setAttribute("action", form.getAttribute("action").replace('add', 'change'))
          quantity.value = 0
        } else {
          if(productForm.dataset.added == "true"){
            productForm.querySelector('button[type="submit"]').click()
            productForm.dataset.added = "false"
          }

          form.setAttribute("action", form.getAttribute("action").replace('change', 'add'))
          quantity.value = 1
        }
      }
    },

    shippingCalculator(width, left){
      let shippingCalculator = this.container.querySelector('shipping-calculator'),
        bar = shippingCalculator.querySelector(".cart__shipping-progress-bar"),
        step = bar.dataset.step,
        totalWidth = parseFloat(bar.dataset.totalWidth, 2),
        paidContent = shippingCalculator.querySelector('.cart__shipping-title-paid'),
        freeContent = shippingCalculator.querySelector('.cart__shipping-title-free'),
        stepsContainer = shippingCalculator.querySelectorAll('.cart__shipping-progress-bar-container .cart__shipping-step-bar');

      left = left ? left : parseFloat(bar.dataset.left, 2),
      width = width ? width : parseFloat(bar.dataset.width, 2);

      let gift = '';
      if(stepsContainer.length > 0){

        for(let i = 0; i < stepsContainer.length; i ++){

          stepsContainer[i].style.left = `calc(${100 * (i + 1) / (parseInt(step) + 1)}% - 16px)`;

          const productForm = stepsContainer[i].querySelector('product-form');

          if(width >= 100 * (i + 1) / (parseInt(step) + 1)) {
            if(productForm) {
              console.log(stepsContainer[i].classList.contains('reached') ? false : true)
              this.checkStatusProductForm(productForm, true,  stepsContainer[i].classList.contains('reached') ? false : true)
            }

            stepsContainer[i].classList.add('reached');
          } else {
            if(productForm) {
              console.log(stepsContainer[i].classList.contains('reached') ? true : false)
              this.checkStatusProductForm(productForm, false, stepsContainer[i].classList.contains('reached') ? true : false)
            }

            if(gift == ''){
              gift = stepsContainer[i].dataset.phrase;
            }

            stepsContainer[i].classList.remove('reached');
          }
        };

        if (gift != "") {
          paidContent.querySelector('.gift').innerText = gift;
        } else {
          freeContent.querySelector('.gift').innerText = stepsContainer[stepsContainer.length - 1].dataset.phrase
        }
      }

      if (left > 0 && width < totalWidth) {
        paidContent.classList.remove('hide');
        freeContent.classList.add('hide');

        setTimeout(function(){
          paidContent.classList.remove('visibility-hidden');
          freeContent.classList.add('visibility-hidden');
        }, 100);

        if(paidContent.querySelector('.cart__shipping-title-paid-price span.money')){
          paidContent.querySelector('.cart__shipping-title-paid-price span.money').innerHTML = theme.Currency.formatMoney(left);
        } else {
          paidContent.querySelector('.cart__shipping-title-paid-price').innerHTML = paidContent.querySelector('.cart__shipping-title-paid-price').textContent.replace('price', `<b>${theme.Currency.formatMoney(left)}</b>`);
        }

        shippingCalculator.querySelector('.cart__shipping-progress-bar-container').classList.remove('hide');

        setTimeout(function(){
          bar.style.width = 'calc(' + width + '% - 16px)';
        }, 500);

      } else {
        freeContent.classList.remove('hide');
        paidContent.classList.add('hide');
        shippingCalculator.querySelector('.cart__shipping-progress-bar-container').classList.add('hide');

        setTimeout(function(){
          freeContent.classList.remove('visibility-hidden');
          paidContent.classList.add('visibility-hidden');
        }, 100);
      }
    },

    keepOnPage(){
      var pageTitle = document.title;
      var attentionMessage = Shopify.translation.keep_on_page;

      document.addEventListener('visibilitychange', function(e) {
        var isPageActive = !document.hidden;

        if(!isPageActive){
          setTimeout(function(){
            document.title = attentionMessage;
          }, 300);
        } else {
          document.title = pageTitle;
        }
      });
    }
  }); 

  return Cart;
})();